// src/pages/HomePage.jsx

import { React } from 'react';
import { Helmet } from 'react-helmet-async';

import { Link } from 'react-router-dom';
import '../styles/dash_styles.css';
import '../styles/contactForm.css';
import '../styles/app.css';
import Navbar from '../components/navbar';
import Footer from '../components/footer';
// import avatar from '../assets/avatar1.png';
import avatar from '../assets/build1.png';
// import avatar from '../assets/avatar1.jpeg';
import ContactForm from '../components/contactForm';
// import StarRating from '../components/starRating';
import TestimonialSlider from '../components/testimonialSlider';
import useScrollAnimation from '../hooks/useScrollAnimation';
import { formatPhoneNumber } from '../utils/phoneFormatter';
import { PHARMACY_NUMBER } from '../constants/constant';
// import { Link } from 'react-router-dom';

function HomePage() {
  const isMobile = window.innerWidth <= 1024;

  useScrollAnimation();


  const bookingSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Pharmacy Appointment Scheduling",
    "serviceType": "Vaccination, Consultation, or Pharmacy Service Appointment",
    "description": "Online booking for services at Mirror Lake Pharmacy, including flu shots, travel consultation, and lab testing.",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Mirror Lake Pharmacy",
      "url": "https://www.mirrorlakepharmacy.ca/",
      "address": {
        "@type": "PostalAddress",
        // IMPORTANT: Replace these with the actual address details
        "streetAddress": "Unit# 103, 5403 48 Ave", 
        "addressLocality": "Camrose", 
        "addressRegion": "AB", 
        "postalCode": "T4V 0J6", 
        "addressCountry": "CA"
      },
      "telephone": `${formatPhoneNumber(PHARMACY_NUMBER)}`
    },
    "potentialAction": {
      "@type": "BookAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.mirrorlakepharmacy.ca/book-appointment", 
        "inLanguage": "en",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "name": "Book Now"
    }
  };

  return (
    <>
      <Helmet>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(bookingSchema) }}
        />
      </Helmet>
      <Navbar />

      {/* Hero Section */}

      <section
        className="hero"
        id="home"
        style={
          isMobile
            ? {
              backgroundImage: `url(${avatar})`,
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              position: 'relative',
            }
            : {}
        }
      >
        {isMobile && <div className="hero-overlay fade-in"></div>}

        <div className="hero-text slide-up">
          <div className="hero-heading">
            {/* <h1>
              Your <span className="highlight-word">community’s</span><br />
              <span className="highlight-word">health</span> partner
            </h1> */}
             <h1>
              Our community’s<br />
              health partner
            </h1>
          </div>
          <p className="fade-in-delay">Providing accessible healthcare, expert advice,<br /> and compassionate service for your family's well-being.</p>
          <a href="#services" className="btn-primary fade-in-delay-2">Explore Our Services</a>
        </div>

        {!isMobile && (
          <div className="hero-image slide-right">
            {/* <img src="/assets/avatar1.png" alt="Consultation" /> */}
            <img src="/assets/building.png" alt="Consultation" />
          </div>
        )}

        <div className="hero-bottom-info">
          <div className="info-box first-info-box slide-up-delay-1">
            <h4>Working Hours</h4>
            <p>Mon – Fri: <strong>9:00 – 18:00</strong></p>
            <hr />
            <p>Saturday: <strong>9:00 – 18:00</strong></p>
            <hr />
            <p>Sunday: <strong>9:00 – 18:00</strong></p>
          </div>

          <div className="info-box third-info-box slide-up-delay-2">
            <h4>Phone Number</h4>
            <p><a className="telephone" href={`tel:${PHARMACY_NUMBER}`}><i className="fa-solid fa-phone"></i> {formatPhoneNumber(PHARMACY_NUMBER)}</a></p>
            <h4>Fax Number</h4>
            <p><a className="telephone" href="tel:+15877691133"><i class="fa-solid fa-fax"></i> +1 (587) 769-1133</a></p>
          </div>
        </div>
      </section>

      <section className="prescription-transfer">
        <div className="prescription-image slide-left">
          <img src="/assets/cameron_1.jpg" alt="Prescription Transfer" />
          {/* <img src="/assets/prescription_transfer.jpg" alt="Prescription Transfer" /> */}
        </div>
        <div className="prescription-text slide-right">
          <div className="prescription-icon fade-in">
            <i className="fas fa-file-prescription"></i>
          </div>
          <h2 className="fade-in-delay">Prescription Transfer</h2>
          <p className="fade-in-delay-2">Tired of waiting on the phone for a Pharmacist?<br /> Need Local Pharmacist who really cares?</p>
          <Link to="/prescription-transfer" className="btn-primary fade-in-delay-3">Transfer Now</Link>
        </div>
      </section>

      {/* Services Section */}
      <section className="services" id="services">
        <h2 className="fade-in">Our Services</h2>
        <div className="service-grid">
          <div className="service-grid">
    {[
      ["fa-percent", "25% Senior Discount", "Everyday for seniors—save more on OTC medications.", false, "will not go below the cost price.*"],
      ["fa-calendar-check", "Open 7 Days a Week", "Pharmacy and Travel Clinic.", false],
      ["fa-user-md", "Prescribing Pharmacist On Duty", "Always on duty to meet your care and prescription needs.", false],
      ["fa-syringe", "Injection Services", "Get your injections administered professionally on-site.", true],
      ["fa-plane", "Travel Consultation", "Before and after your trip.", true],
      ["fa-shipping-fast", "Free Prescription Delivery", "Free and fast delivery of medications to your home.", false],
      ["fa-vials", "Strep & Lab Testing", "Lab work request, strep throat testing, and results review services.", true],
      ["fa-syringe", "Vaccination Services", "COVID, flu, RSV, Shingles vaccinations and more available in-store.", true],
    ].map((item, index) => (
      <div className={`service-card slide-up-delay-${(index % 4) + 1}`} key={index}>
        <i className={`fa ${item[0]}`}></i>
        <h3>{item[1]}</h3>
        <p>{item[2]}</p>
        <p>{item[4]}</p>

        {item[3] && (
          <Link to="/book-appointment" className="btn-secondary" style={{ marginTop: "12px", display: "inline-block" }}>
            Book Now
          </Link>
        )}
      </div>
    ))}
  </div>
          {/* <div className="service-card">
            <i className="fa fa-percent"></i>
            <h3>20% Senior Discount</h3>
            <p>Everyday for seniors—save more on OTC medications.</p>
          </div>

          <div className="service-card">
            <i className="fa fa-calendar-check"></i>
            <h3>Open 7 Days a Week</h3>
            <p>Pharmacy and Travel Clinic.</p>
          </div>

          <div className="service-card">
            <i className="fa fa-user-md"></i>
            <h3>Prescribing Pharmacist On Duty</h3>
            <p>Always on duty to meet your care and prescription needs.</p>
          </div>

          <div className="service-card">
            <i className="fa fa-syringe"></i>
            <h3>Injection Services</h3>
            <p>Get your injections administered professionally on-site.</p>
            <Link to="/book-appointment" className="btn-secondary" style={{ marginTop: '12px', display: 'inline-block' }}>
              Book Now
            </Link>
          </div>

          <div className="service-card">
            <i className="fa fa-plane"></i>
            <h3>Travel Consultation</h3>
            <p>Before and after your trip.</p>
            <Link to="/book-appointment" className="btn-secondary" style={{ marginTop: '12px', display: 'inline-block' }}>
              Book Now
            </Link>
          </div>

          <div className="service-card">
            <i className="fa fa-shipping-fast"></i>
            <h3>Free Prescription Delivery</h3>
            <p>Free and fast delivery of medications to your home.</p>
          </div>

          <div className="service-card">
            <i className="fas fa-vials"></i>
            <h3>Strep & Lab Testing</h3>
            <p>Lab work request, strep throat testing, and results review services.</p>
            <Link to="/book-appointment" className="btn-secondary" style={{ marginTop: '12px', display: 'inline-block' }}>
              Book Now
            </Link>
          </div>

          <div className="service-card">
            <i className="fa fa-syringe"></i>
            <h3>Vaccination Services</h3>
            <p>COVID, flu, RSV, Shingles vaccinations and more available in-store.</p>
            <Link to="/book-appointment" className="btn-secondary" style={{ marginTop: '12px', display: 'inline-block' }}>
              Book Now
            </Link>
          </div> */}
        </div>

        <div className="see-all-button fade-in-delay-3">
          <Link to="/services" className="btn-secondary">See All Services</Link>
        </div>
      </section>

      {/* Discount Banner Section */}
      <section className="discount-banner fade-in">
        <div className="discount-content slide-up">
          <div className="discount-image">
            <img src="/assets/senior_offer.png" alt="Senior Offer" />
          </div>
          <div className="discount-text">
            <p className="discount-tag">EXCLUSIVE OFFERS</p>
            <h2>SAVE MORE EVERYDAY FOR<br />FRONT STORE ITEMS</h2>
            <p className="discount-subtext">Seniors, Military, Teachers and Health Care Professionals</p>
            <h3 className="discount-percentage">30% DISCOUNT ON THURSDAY</h3>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-banner fade-in">
        <div className="about-banner-content slide-up">
          <div className="about-banner-image slide-up">
            <img className="about-phramacist-img" src="/assets/cameron_4.jpg" alt="Pharmacist" />
            <div className="about-tag-circle fade-in">KNOW MORE<br />About Us</div>
            <img className="about-pharmacy" src="/assets/cameron_3.jpg" alt="Pharmacy Store" />
          </div>
          <div className="about-banner-text slide-up">
            <h4>ABOUT US</h4>
            <h2>Cameron DeLong</h2>
            <p>Come experience the warmth of Mirror Lake Pharmacy—where your well-being is our priority, and every visit feels like coming home.</p>

            <p>We’re not just a pharmacy—we’re your neighborhood haven for all things health, happiness, and community. From expert medication management to personalized care, our team is dedicated to helping you live your best life.</p>

            <p>Our lead pharmacist brings over <strong>9 years of clinical experience</strong> and has been <strong>consistently serving the Camrose community through Mirror Lake Pharmacy</strong>. His commitment to patient-centered care ensures you receive the guidance, compassion, and expertise you deserve.</p>

            <p>Explore our wide range of services, from prescription refills to health consultations—all tailored to meet your unique needs.</p>
            <a href="/assets/Pharmacy_Liscense.pdf" target="_blank" className="license-button fade-in">View Pharmacy License</a>
            <hr />
            <p className="call-label fade-in">Make a call now</p>
            <a href={`tel:${PHARMACY_NUMBER}`} className="call-number fade-in"><strong>{formatPhoneNumber(PHARMACY_NUMBER)}</strong></a>
            <a href={`tel:${PHARMACY_NUMBER}`} className="call-button fade-in"><i className="fa-solid fa-phone"></i> Call Now</a>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}

      <TestimonialSlider/>

      {/* Contact Us Section */}
      <section className="contact-us fade-in" id="contact">
        <h2>Contact Us</h2>
        <p>Feel free to reach out to us for any consultation or inquiries!</p>

        <ContactForm />
        <br></br>

        <p><a href="/contact">Know more about our pharmacist</a></p>
      </section>

      <Footer />
    </>
  );
}

export default HomePage;